/**
 * @file index.tsx
 *
 * @fileoverview Shows the gallery widget title when in view mode.
 */
import { FormattedMessage } from 'react-intl';

export const OrganizationGalleryWidgetViewTitle = () => (
  <FormattedMessage
    id="organization_image_gallery_label"
    defaultMessage="Image gallery"
  />
);

export default OrganizationGalleryWidgetViewTitle;
